// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__oMUAp","paramInput":"JobSimulator_paramInput__34Mmu","input":"JobSimulator_input__3-r1b"};